<template>
    <div
        v-if="isDisabled"
        class="plan-calendar__day"
    >
        {{ day }}
    </div>
    <v-menu
        v-else-if="!events[currentDateFormatted]"
        lazy
        offset-y
        :close-on-content-click="false"
    >
        <template #activator="{ on }">
            <button
                :class="{
                    'plan-calendar__day-btn': true,
                    'plan-calendar__day-btn_current':
                        currentDateFormatted === dayjs().format('YYYY.MM.DD'),
                    'plan-calendar__day-btn_selected': selectedRange.includes(currentDateFormatted),
                    'plan-calendar__day-btn_left-round': accesses && isSelectionDayLeftRound,
                    'plan-calendar__day-btn_right-round': accesses && isSelectionDayRightRound,
                }"
                @mousedown="mousedownHandle"
                @mouseenter="mouseoverHandle"
                @mouseup="accesses && mouseupHandle($event, on)"
                @click="!accesses && mouseupHandle($event, on)"
            >
                {{ day }}
            </button>
        </template>
        <v-list class="py-0">
            <v-list-tile
                v-for="item in eventTypeList"
                :key="item.value"
                class="plan-calendar__menu-item"
                @click="clickMenuItemHandle(item.value)"
            >
                <v-list-tile-title>
                    <v-icon
                        v-if="item.icon"
                        size="large"
                        class="plan-calendar__menu-icon"
                    >
                        {{ item.icon }}
                    </v-icon>
                    {{ item.label }}
                </v-list-tile-title>
            </v-list-tile>
        </v-list>
    </v-menu>
    <v-tooltip v-else lazy bottom>
        <template #activator="{ on: tooltip }">
            <v-menu offset-y>
                <template #activator="{ on: menu }">
                    <button
                        :class="{
                            'plan-calendar__day-btn': true,
                            'plan-calendar__day-btn_current': currentDateFormatted === dayjs().format('YYYY.MM.DD'),
                            'plan-calendar__day-btn_selected': events[currentDateFormatted].id === hoverEventId,
                            'plan-calendar__day-btn_yellow': checkEventByType(monthIndex, day, eventTypes.webinar),
                            'plan-calendar__day-btn_blue': checkEventByType(monthIndex, day, eventTypes.training),
                            'plan-calendar__day-btn_orange': checkEventByType(monthIndex, day, eventTypes.workshop),
                            'plan-calendar__day-btn_grey': checkEventByType(monthIndex, day, eventTypes.other),
                            'plan-calendar__day-btn_left-round': isMultiEventLeftRound,
                            'plan-calendar__day-btn_right-round': isMultiEventRightRound,
                        }"
                        v-on="{ ...tooltip, ...menu }"
                        @mouseenter="eventDayHoverHandle"
                        @mouseleave="eventDayLeaveHandle"
                    >
                        {{ day }}
                    </button>
                </template>
                <v-list class="py-0">
                    <v-list-tile
                        v-for="item in menuList"
                        :key="item.value"
                        class="plan-calendar__menu-item"
                        @click="clickMenuItemHandle(item.value)"
                    >
                        <v-list-tile-title>
                            <v-icon size="large" class="plan-calendar__menu-icon">{{ item.icon }}</v-icon>
                            {{ $t(item.label) }}
                        </v-list-tile-title>
                    </v-list-tile>
                </v-list>
            </v-menu>
        </template>
        <div class="plan-calendar__comment">
            <span v-if="events[currentDateFormatted].comment">{{ events[currentDateFormatted].comment }}</span>
            <br v-if="events[currentDateFormatted].comment">
            <span>{{ `Изменено: ${events[currentDateFormatted].updater} ${events[currentDateFormatted].updatedDate}` }}</span>
        </div>
    </v-tooltip>
</template>

<script>
import {mapGetters} from 'vuex';
import dayjs from 'dayjs';

export default {
  props: {
    monthIndex: {
      type: Number,
    },
    day: {
      type: Number,
    },
    hoverEventId: {
      type   : [Number, null],
      default: null,
    },
    events: {
      type   : Object,
      default: () => ({}),
    },
    eventTypeList: {
      type   : Array,
      default: () => [],
    },
    menuList: {
      type   : Array,
      default: () => [],
    },
    selectedRange: {
      type   : Array,
      default: () => [],
    },
    isStartRangeSelect: {
      type   : Boolean,
      default: false,
    },
  },
  data: () => ({
    dayjs,
    toggleMenu: false,
  }),
  computed: {
    ...mapGetters('study_plan', ['get_disabled_dates']),
    ...mapGetters('profile/user', [
      'user',
    ]),
    accesses() {
      if (this.user.role) {
        return !!this.user.role.managment_study_events.rights.length;
      }
      return false;
    },
    currentDate() {
      return dayjs().set('month', this.monthIndex).set('date', this.day);
    },
    currentDateFormatted() {
      return dayjs().set('month', this.monthIndex).set('date', this.day).format('YYYY.MM.DD');
    },
    eventTypes() {
      return this.eventTypeList.reduce((acc, event) => {
        acc[event.value] = event.value;
        return acc;
      }, {});
    },
    isSelectionDayRightRound() {
      return (this.isStartRangeSelect || this.selectedRange.includes(this.currentDateFormatted)) &&
                this.selectedRange.includes(this.currentDate.add(-1, 'day').format('YYYY.MM.DD'));
    },
    isSelectionDayLeftRound() {
      return (this.isStartRangeSelect || this.selectedRange.includes(this.currentDateFormatted)) &&
                this.selectedRange.includes(this.currentDate.add(1, 'day').format('YYYY.MM.DD'));
    },
    isMultiEventRightRound() {
      const currentEvent = this.events[this.currentDateFormatted];
      const prevEvent = this.events[this.currentDate.add(-1, 'day').format('YYYY.MM.DD')];
      if (currentEvent && prevEvent) {
        return currentEvent.id === prevEvent.id;
      }
      return false;
    },
    isMultiEventLeftRound() {
      const currentEvent = this.events[this.currentDateFormatted];
      const nextEvent = this.events[this.currentDate.add(1, 'day').format('YYYY.MM.DD')];
      if (currentEvent && nextEvent) {
        return currentEvent.id === nextEvent.id;
      }
      return false;
    },
    isDisabled() {
      const isGrantDisabled = this.get_disabled_dates.includes(this.currentDateFormatted);

      if (this.user.role && !this.user.role.managment_study_events.rights.length) {
        return isGrantDisabled || this.currentDate.isBefore(dayjs());
      }
      return isGrantDisabled ||
        (this.currentDate.isBefore(dayjs()) && !this.events[this.currentDateFormatted]);
    },
  },
  methods: {
    eventDayHoverHandle() {
      this.$emit('event-day-hover', this.events[this.currentDateFormatted].id);
    },
    eventDayLeaveHandle() {
      this.$emit('event-day-leave');
    },
    clickMenuItemHandle(eventType) {
      this.$emit('menu-item-click', eventType, this.currentDate);
    },
    checkEventByType(month, day, eventType) {
      return this.events[this.currentDateFormatted] &&
                this.events[this.currentDateFormatted].type === eventType;
    },
    mousedownHandle() {
      this.$emit('close-menu');
      this.$emit('start-range-select', true);
      if (!this.isDisabled && !this.events[this.currentDateFormatted]) {
        this.$emit('update-selected-range', this.currentDateFormatted);
      }
    },
    mouseoverHandle() {
      if (!this.isDisabled && !this.events[this.currentDateFormatted]) {
        this.$emit('update-selected-range', this.currentDateFormatted);
      }
    },
    mouseupHandle(event, menuHandlers) {
      setTimeout(() => {
        menuHandlers.click(event);
      }, 0);
    },
  },
};
</script>
